import axios from './axios'

/**
 * Which ways in this particular server offers (CV-844).
 *
 * Sign in with Google is switched on per server, so the screen has to ask rather than
 * assume: a Google button drawn on a server that has no Google settings is a button
 * that leads nowhere. Answers { google: true } or { google: false }.
 */
export const getAuthConfig = () => {
  return axios.get('/v2/auth/config')
}

export const login = (body) => {
  return axios.post('/v2/auth/login', body)
}

export const forgotPassword = ({ email }) => {
  return axios.post('/v2/auth/forgot-password', { email })
}

export const resetPassword = ({ token, password }) => {
  return axios.post(`/v2/auth/reset-password/${token}`, {
    password
  })
}
